import { render } from "./UserSignUp.vue?vue&type=template&id=7fbc27a8"
import script from "./UserSignUp.vue?vue&type=script&lang=js"
export * from "./UserSignUp.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__